import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import RoleListCell from "./CustomCells/RoleList";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import RoleCellRenderer from "../UserManagement/RoleCellRenderer";
import UserCellRenderer from "../UserManagement/DeleteUserModal/UserCellRenderer";
import DeviceCellRenderer from "./CustomCells/DeviceCellRenderer";
import TruckCellRenderer from "./CustomCells/TruckCellRenderer";
import TagSchemeCellRenderer from "./CustomCells/TagSchemeCellRenderer";

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, searchVal, openModal }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [allRows, setAllRows] = useState<any[]>([]);
  const [original, setOriginal] = useState<any[]>([]);

  // filters table for when user types in search value
  useEffect(() => {
    if (searchVal && searchVal !== "") {
        let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      //console.log(flatData);
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];

      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = {
          field: keys[i],
          resize: true,
          sortable: true
        }
        if (keys[i] === "roleName") {
          let temp = keys[0];
          //newKeys[0] = {field: "roleName"};
          //obj = { field: temp };
        }
        if (keys[i] === "deviceTypeName") {
          obj = { headerName: 'Device Type', field: keys[i] }
       }
        if (keys[i] === "deviceId") {
          obj = { headerName: 'Device ID', field: keys[i] }
      }

        // keys that need to be hidden
        if (keys[i] === "truckId" || keys[i] === "iotDeviceId" || keys[i] === "isCameraConnected" || keys[i] === "roleId" || keys[i] === "userId" || keys[i] === "timeZone" || keys[i] === "dateFormat" || keys[i] === "numberFormat" || keys[i] === "sfId") {
          obj = { field: keys[i], hide: true }
        }

        if (keys[i] === "roleName") {
          obj = {
            field: keys[i], minWidth: 200,
            resizable: true,
            cellRendererSelector: (params: any) => {
              return { component: RoleCellRenderer }
            },
            cellRendererParams: openModal ?
            {
                deleteAction: (modal: any, user: any) => openModal(modal, user),
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
        } else if (keys[i] === "email") {
          obj = {
            field: keys[i], minWidth: 200,
            resizable: true,
                  cellRendererSelector: (params: any) => {
              return { component: UserCellRenderer }
            },
                  cellRendererParams: openModal ?
                      {
                deleteAction: (modal: any, user: any) => openModal(modal, user),
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
          } else if (keys.includes("deviceTypeName") && keys[i] === "deviceId") {
          obj = {
            field: keys[i], minWidth: 200,
                headerName: 'Device ID',
            resizable: true,
                  cellRendererSelector: (params: any) => {
              return { component: DeviceCellRenderer }
            },
                  cellRendererParams: openModal ?
                      {
                deleteAction: (modal: any, user: any) => openModal(modal, user),
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
        } else if (keys[i] === "tagSchemeName") {
          obj = {
            field: keys[i], minWidth: 200,
            resizable: true,
                  cellRendererSelector: (params: any) => {
              return { component: TagSchemeCellRenderer }
            },
                  cellRendererParams: openModal ?
                      {
                deleteAction: (modal: any, user: any) => openModal(modal, user),
                          editAction: (modal: any, user: any) => openModal(modal, user)
                      } :
                      {}
              }
          }


        if (keys[i] === "userRoleList") {
          obj = {
            field: keys[i],
            cellRendererSelector: (params: any) => {
              return { component: RoleListCell }
            },

          }
        }
        if (keys.includes("observation1Description") && keys[i] === "truckName") {
          obj = { field: keys[i], headerName: 'Truck Number' }
        }
          if (keys[i] === "serviceProviderNme") {
          obj = { field: keys[i], headerName: 'Service Provider Name', width: 300 }
          }
        if (keys[i] === "lastUpdateDate") {
          obj = { field: keys[i], headerName: 'Last Updated Date' }
        }
          if (keys[i] === "observation1Description") {
          obj = { field: keys[i], headerName: 'Observation 1 Description', width: 300 }
          }
          if (keys[i] === "observation2Description") {
          obj = { field: keys[i], headerName: 'Observation 2 Description', width: 300 }
          }
          if (keys[i] === "observation3Description") {
          obj = { field: keys[i], headerName: 'Observation 3 Description', width: 300 }
          }
        if (keys.includes("warehouseLocationNAme") && keys[i] === "truckName") {
          //console.log(keys[i]);
          obj = {
            field: keys[i], minWidth: 200,
            resizable: true,
                cellRendererSelector: (params: any) => {
              return { component: TruckCellRenderer }
            },
                cellRendererParams: openModal ?
                    {
                deleteAction: (modal: any, user: any) => openModal(modal, user),
                        editAction: (modal: any, user: any) => openModal(modal, user)
                    } :
                    {}
            }
        }

        if (keys.includes("warehouseLocationNAme") && (keys[i] === "truckId" ||  keys[i] === "iotDeviceId")) {
          obj = { field: keys[i], hide: true }
        }

        if ((keys[i] === "tagSchemeId")) {
          obj = { field: keys[i], hide: true }
          }

        obj.resizable = true;
        if (keys[i] === "email" || (keys[i] === "truckName") && keys.includes("warehouseLocationNAme")) {
              newKeys.unshift(obj);
        } else if (keys[i] === "roleName") {
              newKeys.unshift(obj);
        } else if (keys[i] === "deviceId") {
              newKeys.unshift(obj);
        } else {
              newKeys.push(obj);
            }
      }

      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
      setAllRows(newRows);
    }
    else {
      setRows([]);
      setOriginal([]);
      setColumns([
        { headerName: 'Tag Scheme Name', field: 'TagSchemeName' },
        { headerName: 'Tag Scheme Status', field: 'TagSchemeStatus' },
        { headerName: 'Description', field: 'Description' },
        { headerName: 'Tag Scheme Length', field: 'TagSchemeLength' },
        { headerName: 'Header Format', field: 'HeaderFormat' },
        { headerName: 'Header Length', field: 'HeaderLength' },
        { headerName: 'Header Id', field: 'HeaderId' },
        { headerName: 'Serial Number Format', field: 'SerialNumberFormat' },
        { headerName: 'Serial Number Length', field: 'SerialNumberLength' },
        { headerName: 'Serial Number Id', field: 'SerialNumberId' },
        { headerName: 'Creation Date', field: 'CreationDate' },
        { headerName: 'Created By', field: 'CreatedBy' },
        { headerName: 'Last Updated Date', field: 'LastUpdateDate' },
        { headerName: 'Last Updated By', field: 'LastUpdateBy' },
      ]);
        setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: true,
    filter:'agSetColumnFilter',
    resizable: true
  };

  return (
    <Box className="ag-theme-material" sx={{ height: "100%", width: '100%' }}>
      <AgGridReact
        defaultColDef={defaultColDef}
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={100}
        suppressHorizontalScroll={false}
        suppressPreventDefaultOnMouseWheel={true}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default TableComponent;
